import React, { useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { bigBtn, choiceBtn, gcard } from "./gedKit";

const HOURS = [["Mon", 6], ["Tue", 8], ["Wed", 5], ["Thu", 9], ["Fri", 7]];
const SAVE = [["Jan", 100], ["Feb", 160], ["Mar", 220], ["Apr", 180], ["May", 260]];

const Bar = () => (
  <svg viewBox="0 0 300 180" className="w-full" data-testid="chart-bar">
    {[0, 5, 10].map((v) => <g key={v}><line x1="34" x2="290" y1={150 - v * 13} y2={150 - v * 13} stroke="rgba(255,255,255,0.15)" /><text x="26" y={154 - v * 13} fill="white" fontSize="11" textAnchor="end">{v}</text></g>)}
    {HOURS.map(([d, h], i) => <g key={d}><rect x={46 + i * 50} y={150 - h * 13} width="32" height={h * 13} rx="4" fill="#38bdf8" /><text x={62 + i * 50} y="168" fill="white" fontSize="12" textAnchor="middle">{d}</text></g>)}
    <text x="6" y="12" fill="white" fontSize="11">Hours worked</text>
  </svg>
);

const Line = () => {
  const pts = SAVE.map(([, v], i) => `${46 + i * 58},${150 - v * 0.48}`).join(" ");
  return (
    <svg viewBox="0 0 300 180" className="w-full" data-testid="chart-line">
      {[0, 100, 200, 300].map((v) => <g key={v}><line x1="34" x2="290" y1={150 - v * 0.48} y2={150 - v * 0.48} stroke="rgba(255,255,255,0.15)" /><text x="30" y={154 - v * 0.48} fill="white" fontSize="10" textAnchor="end">${v}</text></g>)}
      <polyline points={pts} fill="none" stroke="#d4a017" strokeWidth="3" />
      {SAVE.map(([m, v], i) => <g key={m}><circle cx={46 + i * 58} cy={150 - v * 0.48} r="5" fill="#d4a017" /><text x={46 + i * 58} y="168" fill="white" fontSize="12" textAnchor="middle">{m}</text></g>)}
      <text x="6" y="12" fill="white" fontSize="11">Savings</text>
    </svg>
  );
};

const Para = () => (
  <p className="text-lg leading-relaxed rounded-xl bg-white/5 p-4" data-testid="chart-para">
    Community gardens do more than grow food. Neighbors who garden together get to know each other. They share tools, swap tips, and look out for one another. Many cities now say gardens help make neighborhoods safer and friendlier.
  </p>
);

const ITEMS = [
  { tip: "Read the title and the labels first. Then compare bar heights.", Visual: Bar, q: "Which day had the most hours worked?", choices: ["Monday", "Tuesday", "Thursday", "Friday"], a: 2, why: "Thursday's bar is tallest: 9 hours." },
  { tip: "On a line chart, a line going down means the number dropped.", Visual: Line, q: "Between which two months did savings go down?", choices: ["Jan to Feb", "Feb to Mar", "Mar to Apr", "Apr to May"], a: 2, why: "The line falls from $220 in March to $180 in April." },
  { tip: "The main idea is what the whole paragraph is about, not one detail.", Visual: Para, q: "What is the main idea?", choices: ["Gardens need lots of tools", "Community gardens bring neighbors together", "Cities grow most of our food", "Gardening is hard work"], a: 1, why: "Every sentence supports how gardens connect neighbors. The other choices are small details or not in the text." },
];

export default function Charts({ voice, onDone }) {
  const [i, setI] = useState(0);
  const [pick, setPick] = useState(null);
  const it = ITEMS[i];
  const ok = pick == null ? null : pick === it.a;
  const choose = (j) => { if (pick != null) return; setPick(j); voice.play(j === it.a ? "right" : "wrong"); };
  const next = () => { setPick(null); i + 1 < ITEMS.length ? setI(i + 1) : onDone(); };
  return (
    <div className="space-y-4" data-testid="lp-part-charts">
      <div className={`${gcard} space-y-4`} key={i}>
        <div className="text-xs uppercase tracking-[0.25em] text-[#d4a017]">{i + 1} of {ITEMS.length}</div>
        <p className="text-sm text-white/70">{it.tip}</p>
        <it.Visual />
        <p className="text-lg font-medium">{it.q}</p>
        <div className="space-y-2">{it.choices.map((c, j) => (
          <button key={c} type="button" onClick={() => choose(j)} data-testid={`chart-choice-${j}`}
            className={`${choiceBtn} ${pick == null ? "border-white/15" : j === it.a ? "border-emerald-400 bg-emerald-500/15" : j === pick ? "border-red-400 bg-red-500/15" : "border-white/10 opacity-60"}`}>{c}</button>
        ))}</div>
        {ok != null && <div data-testid="chart-result" className={`flex gap-2 rounded-xl p-3 ${ok ? "bg-emerald-500/15" : "bg-red-500/15"}`}>{ok ? <CheckCircle2 className="h-6 w-6 shrink-0 text-emerald-300" /> : <XCircle className="h-6 w-6 shrink-0 text-red-300" />}<span>{it.why}</span></div>}
        {ok != null && <button type="button" onClick={next} className={bigBtn} data-testid="chart-next">{i + 1 < ITEMS.length ? "Next" : "Finish Part 3"}</button>}
      </div>
    </div>
  );
}
